/**
 * Temporary component for the "Skip" button of the first step
 * The whole process should be using components
 */

// Import dependencies
import { unsafeCSS, css, html, LitElement, render } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { isDefined } from '@automator/utilities';

// Get translatable strings
const strings = UncannyAutomatorBackend.setupWizard.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-setup-wizard-step-1-skip' )
export class AutomatorSetupWizardStep1Skip extends LitElement {
	// Define properties
	@property( { type: String, attribute: 'url-next-step' } ) accessor urlNextStep;

	@property( { type: String, attribute: 'url-connect-account' } ) accessor urlConnectAccount;

	// Create a reference to the dialog that doesn't exist yet
	$dialog = createRef();

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="button">
				<uo-button
					color="transparent"
					@click=${ this.createDialog }
				>
					${ strings.skipThis }
				</uo-button>
			</div>
		`;
	}

	/**
	 * Creates the dialog with the log data
	 * It also resizes the dialog when the child component shows or hides the sidebar
	 */
	createDialog() {
		// Create the node that we'll use to render the dialog
		// This node will be added as a direct child of the body node.
		// We can't add it inside the component created on this class because of z-index issues
		const $wrapper = document.createElement( 'div' );
		document.body.append( $wrapper );

		render(
			html`
				<uo-dialog
					heading=${ strings.areYouSure }
					size="small"
					open
				>
					${ strings.freeAccountFeatures }
					
					<uo-button
						slot="primary-action"
						href=${ this.urlConnectAccount }
					>
						${ strings.signUpNow }
					</uo-button>

					<uo-button
						slot="secondary-action"
						color="secondary"
						href=${ this.urlNextStep }
					>
						${ strings.skipForNow }
					</uo-button>
				</uo-dialog>
			`,
			$wrapper
		);
	}
}